import { render, staticRenderFns } from "./flagged-costs-form.vue?vue&type=template&id=f2bf727a&scoped=true"
import script from "./flagged-costs-form.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-form.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-form.vue?vue&type=style&index=0&id=f2bf727a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bf727a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2bf727a')) {
      api.createRecord('f2bf727a', component.options)
    } else {
      api.reload('f2bf727a', component.options)
    }
    module.hot.accept("./flagged-costs-form.vue?vue&type=template&id=f2bf727a&scoped=true", function () {
      api.rerender('f2bf727a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-form/flagged-costs-form.vue"
export default component.exports